export const CountryData = `
    id
    code
    dialCode
    name
    isActive
    lastModifiedAt
`;
